'use client';
import Link from 'next/link';
import React from 'react';
import { FaXmark } from 'react-icons/fa6';
import { useAppDispatch } from '@/lib/redux/hooks';
import { toggleWishlistItem } from '@/lib/redux/features/wishlist';
import { addItem } from '@/lib/redux/features/cart';
interface WishlistItem {
  id: string;
  title?: string;
  imgSrc?: string;
  price: number;
  rating?: number;
  reviews?: number;
  quantity: number;
  categories?: string;
}
const WishlistTableRow = ({ product }: { product: WishlistItem }) => {
  const dispatch = useAppDispatch();

  const removeProduct = () => {
    dispatch(toggleWishlistItem(product));
  };

  return (
    <tr>
      <td className="cart__item">
        <div className="cart__item-thumb">
          <Link href="#">
            <img src={product.imgSrc} alt={product.title} />
          </Link>
        </div>
        <div className="cart__item-content">
          <h4>
            <Link href="#">{product.title}</Link>
          </h4>
        </div>
      </td>
      <td className="align-middle">
        ${product.price ? Number(product.price).toFixed(2) : '0.00'}
      </td>

      <td className="align-middle">
        <a
          onClick={() => dispatch(addItem(product))}
          className="trk-btn trk-btn--outline "
        >
          Add to cart
        </a>
      </td>

      <td className="align-middle">
        <div className="close-btn">
          <span style={{ cursor: 'pointer' }} onClick={() => removeProduct()}>
            <FaXmark />
          </span>
        </div>
      </td>
    </tr>
  );
};

export default WishlistTableRow;
